import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../../shared';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';
import {FacilitiesCalendarEventLinkContainerModel} from '../../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class FacilitiesCalendarEventLinkService extends BaseApiPublicLoginTemplateService<FacilitiesCalendarEventLinkContainerModel, FacilitiesCalendarEventLinkContainerModel, FacilitiesCalendarEventLinkContainerModel> {

  static readonly FACILITY_EVENT_LINK_SUB_PATH = 'facilities-cal-event-links/';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + FacilitiesCalendarEventLinkService.FACILITY_EVENT_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + FacilitiesCalendarEventLinkService.FACILITY_EVENT_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + FacilitiesCalendarEventLinkService.FACILITY_EVENT_LINK_SUB_PATH + BaseApiPublicLoginTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }
}
